/** Radix row-action (⋯) menu styling shared by the Library tables. */
export const rowMenuClass = 'z-[300] min-w-44 rounded-control border border-rule bg-surface p-1 shadow-lg';
export const rowMenuItemClass = 'flex cursor-default items-center gap-2 rounded px-3 py-2 text-sm outline-none data-[highlighted]:bg-field data-[disabled]:opacity-40';
